import apiClient from './apiService';
import Cookies from 'js-cookie';

const authService = {

  login: async (email, password) => {
    const response = await apiClient.post('/api/auth/login', {
      email,
      password,
    });

    const { token, user } = response;

    Cookies.set('authToken', token, {
      secure: true,
      sameSite: 'strict',
    });

    Cookies.set('user', JSON.stringify(user), {
      secure: true,
      sameSite: 'strict',
    });

    return { user, token };
  },

  logout: async () => {
    try {
      await apiClient.get('/api/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      Cookies.remove('authToken');
      Cookies.remove('user');
    }
  },


  getToken: () => {
    return Cookies.get('authToken');
  },


  isAuthenticated: () => {
    return !!Cookies.get('authToken');
  },

  
  getUser: () => {
    const user = Cookies.get('user');
    return user ? JSON.parse(user) : null;
  },
};

export default authService;
